// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__1jcVu","blink":"Loading_blink__1xoUE"};